module.exports = __webpack_public_path__ + "static/media/swapActive.46dfbc40.png";